import * as Api from '@ViewModels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { useErrorMessages } from '../../hooks';
import { ApiClient } from '../../services/api';
import { formatOptional } from '../utils/criteriaBuilder';
import { useStatesOnFetch } from '../utils/useStatesOnFetch';
import {
	ILeaderboardDemos,
	ILeaderboardDemosFilterCriteria,
	LeaderboardDemosFilterCriteriaProperty,
} from './../../viewModels/gamification';

export type LeaderboardDemosGroupBy = 'Vertical' | 'QuotaTeam';

export interface ILeaderboardDemosFilter {
	day?: string;
	groupBy?: LeaderboardDemosGroupBy;
}

function filterToCriteria(filter: ILeaderboardDemosFilter): ILeaderboardDemosFilterCriteria[] {
	const criteria: ILeaderboardDemosFilterCriteria[] = [];

	criteria.push(
		formatOptional<LeaderboardDemosFilterCriteriaProperty>(LeaderboardDemosFilterCriteriaProperty.Day, filter?.day)
	);

	return criteria.filter(item => !!item);
}

interface IParams {
	filter: ILeaderboardDemosFilter;
}

export const useLeaderboardDemos = () => {
	const { state, handleWorking, handleResponse, reset } = useStatesOnFetch<ILeaderboardDemos>();

	const userSession = useUserSession();
	const errorMessages = useErrorMessages();

	const client = new ApiClient(userSession);

	const get = async ({ filter }: IParams) => {
		handleWorking();
		try {
			const response = await client.getLeaderboardDemos(filterToCriteria(filter), filter?.groupBy);
			if (!response.success) {
				throw Api.asApiError(response);
			}
			handleResponse(response);
			return response;
		} catch (error) {
			errorMessages.pushApiError(error);
		}
	};

	return {
		...state,
		empty: !state?.data,
		get,
		reset,
		status: state.status,
	};
};
